import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as fromRoot from 'src/app/reducers';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { BrandName, EnvironmentName, Language } from '~environments/env.interface';
import * as resourceBundle from 'src/assets/resource-bundle/index'
import { ResourceBundle, ResourceBundleEnglishRoyalProd } from 'src/assets/resource-bundle/resource-bundle';

@Injectable()
export class ResourceBundleService {
	public resourceBundle$: Observable<any>;
	public content$: Observable<any>;
	public contentRetrieval$: Observable<any>;

	constructor(private store: Store<fromRoot.AppState>) {
		this.resourceBundle$ = this.store.pipe(select(fromRoot.getSiteResourceBundle));
		this.content$ = this.store.pipe(select(fromRoot.getContentResourceList));
		this.contentRetrieval$ = this.store.pipe(select(fromRoot.getContentRetrieval));
	}

	get bundle(): Observable<any> {
		return this.resourceBundle$;
	}

	get content(): Observable<any> {
		return this.content$;
	}

	get contentSnapshot() {
		let content;

		this.content$.pipe(take(1)).subscribe(c => (content = c));

		return content;
	}

	get bundleSnapshot() {
		let bundle: any;

		this.resourceBundle$.pipe(take(1)).subscribe(b => (bundle = b));

		return bundle;
	}

	get isPopulated(): boolean {
		let result = false;

		this.contentRetrieval$.pipe(take(1)).subscribe(b => (result = !!b));

		return result;
	}

	get isPDetailContentPopulated(): boolean {
		let result = false;

		this.content.pipe(take(1)).subscribe(b => (result = b && b.statesList));

		return result;
	}

	replacePlaceholder(key: any, placeholder: any, value: any) {
		const bundle = this.bundleSnapshot;
		if (!bundle) {
			return key;
		}
		if (!bundle[key]) {
			return '[' + key + ']';
		}

		return bundle[key].replace(placeholder, value);
	}

  getResourceBundle(environment: EnvironmentName, brand: BrandName, language: Language) : ResourceBundle {
    const context =`${environment}-${brand}-${language}`;
    const resourceBundleClass = (resourceBundle.resourceBundleConfig as any)[context] ?? new ResourceBundleEnglishRoyalProd();
    return resourceBundleClass.getResourceBundle();
  }

}
